import { Navigate, Route, Routes, RouterProvider, createBrowserRouter } from 'react-router-dom';
import { LayoutPublic } from '../components/LayoutPublic';
import { HomePage, LoginPage, RegisterPage } from '../pages';
import { useContext } from 'react';
import { AuthContext } from '../context/authContext';

export const PublicRoutes = () => {
    const { isAuthenticated } = useContext(AuthContext);

    return (
        <LayoutPublic>
            <div className="flex flex-col flex-1 bg-white dark:bg-gray-900 dark:text-white ">
                <Routes>
                    <Route path='/' element={<HomePage />} />
                    <Route path='login' element={isAuthenticated ? <Navigate to='/inicio' replace /> : <LoginPage/>} />
                    <Route path='register' element={<RegisterPage />} />
                    {/*<Route path='update/:token' element={<UpdatePage />}  />*/}
                    <Route path='*' element={<Navigate to='/login' replace />} />
                </Routes>
            </div>
        </LayoutPublic>
    );
};

